interface IApi {
    Auth: {
        login: string;
    },
    BaseData: {
      getSetting: string;
      editSetting: string;      
      getSliders: string;
      getContactUs: string;
      getSlider: string;
      addSlider: string;
      editSlider: string;
      deleteSlider: string;
    },
    Projects: {
      getProjects: string;
      addProjects: string;
      editProjects: string;
      deleteProjects: string;
    },
    Standards: {
      getStandards: string;
      addStandards: string;
      editStandards: string;
      deleteStandards: string;
    }
}

export const Api: Readonly<IApi> = {
  Auth: {
    login: 'Authenticate/Login'
  },
  BaseData: {
    getSetting: "BaseData/GetSetting",
    editSetting: "BaseData/EditSetting",    
    getSliders: "BaseData/GetSliders",
    getContactUs: "BaseData/GetContactUs",
    getSlider: "BaseData/GetSlider",
    addSlider: "BaseData/AddSlider",
    editSlider: "BaseData/EditSlider",
    deleteSlider: "BaseData/DeleteSlider/{sliderId}"
  },
  Projects: {
    getProjects: "Projects/GetProjectsList",
    addProjects: "Projects/AddProject",
    editProjects: "Projects/EditProject",
    deleteProjects: "Projects/{projectId}"
  },
  Standards: {
    getStandards: "Standards/GetStandardsList",
    addStandards: "Standards/AddStandard",
    editStandards: "Standards/EditStandard",
    deleteStandards: "Standards/{standardId}"
  }
}
